import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import {
	INITIALIZE_APP_PROPS,
	SET_DATA,
	type InitializeAppPropsAction,
	type SetDataAction,
} from '../../actions/app';
import type { AppState } from './types';

type Action = InitializeAppPropsAction | SetDataAction;

const defaultState: AppState = {
	baseUrl: '',
	// @ts-expect-error - TS2322 - Type '{ baseUrl: string; locale: "en_US"; boardId: number; projectKey: null; isFirstDataLoaded: false; }' is not assignable to type 'AppState'.
	locale: defaultLocale,
	boardId: 0,
	projectKey: null,
	isFirstDataLoaded: false,
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppState = defaultState, action: Action): AppState => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS:
			return {
				...state,
				...action.payload,
			};
		case SET_DATA:
			return {
				...state,
				isFirstDataLoaded: true,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
